import * as DKFDS from 'dkfds';
import $ from 'jquery';

let searchResult = null;
let wasPosted = false;

function clearSearchResult($searchResults) {
    searchResult = null;
    $searchResults.find('tbody').html("");
    $searchResults.hide();
    $('#roadNotFound').hide();
    $('#error').hide();
}

export function showAreaSearchResult(areaSearchResult) {
    const $searchResults = $('#searchResults');
    clearSearchResult($searchResults);
    searchResult = areaSearchResult;
    const controls = [];
    const rows = [];
    $.each(areaSearchResult, function (index, result) {
        controls.push(`streetResult${index}`);
        rows.push(`
            <tr>
                <td>
                    <div class="form-group-checkbox">
                        <input id="streetResult${index}" name="streetResult" value="${index}" type="checkbox"
                               class="form-checkbox" aria-label="Vælg ${result.displayName}">
                        <label class="form-label" for="streetResult${index}"></label>
                    </div>
                </td>
                <td><label for="streetResult${index}">${result.roadNumber}-${result.roadPart}</label></td>
                <td><label for="streetResult${index}">${result.displayName}</label></td>
                <td><label for="streetResult${index}">${result.authorityName}</label></td>
            </tr>
        `);
    });
    $searchResults.find('tbody').html(rows.join(''));
    document.getElementById('select-all-streets').setAttribute('aria-controls', controls.join(' '));
    new DKFDS.TableSelectableRows($searchResults.get(0)).init();
    $searchResults.attr('aria-busy', 'false').show();
    $('#addStreetsModal .table-actions').show();
}

function addSites() {
    const siteIndexes = $('input:checkbox:checked[name=streetResult]').map(function () {
        return this.value;
    }).get();
    const sites = [];
    const $streetname = $('#streetname');
    if (siteIndexes.length > 0 || $streetname.val() !== '') {
        // TODO: Hvor kommer streetname fra? Jeg tror ikke denne del er færdig implementeret. Jeg tror den hænger sammen med 'Jeg fandt ikke, hvad jeg søgte'.
        if ($streetname.val()) {
            sites.push({
                'authority': $('#authority').val(),
                'displayname': $streetname.val()
            });
        }
        $.each(siteIndexes, function (index, siteIndex) {
            const site = searchResult[siteIndex];
            if (!site.roadNumber) {
                console.log('Intet vejnummer');
            } else {
                sites.push(site);
            }
        });
        wasPosted = true;
        $('#addedSites').val(JSON.stringify(sites)).closest('form').submit();
        // $('#addStreetsModal').modal('hide');
    } else {
        $('#errorMessage').html('Der er ikke valgt nogen vej(e)').show();
        $('#error').show();
    }
}

export function cancel() {
    location.reload();
}

$(() => {
    const $modal = $('#addStreetsModal');
    wasPosted = false;

    // Because map.js loads this module on pages where we don't have this modal, we need to be careful

    $modal.get(0)?.addEventListener('fds.modal.shown', () => {
        $('#loading').show();
    });

    $modal.get(0)?.addEventListener('fds.modal.hidden', () => {
        if (!wasPosted) {
            location.reload();
        }
    });

    $('#addStreetsModalOK').on('click', () => addSites());
});
